import LandingHeader from "../../components/layout/landingHeader";
import arquImg from "../../assets/images/arqu.png";
import integrationlayer from "../../assets/images/integrationlayer.png";
import AIIntelligenceLayer from "../../assets/images/AIIntelligenceLayer.png";
import FinancialMathematicsEngine from "../../assets/images/FinancialMathematicsEngine.png";
import cloud from "../../assets/images/cloud.png";
import chard from "../../assets/images/chard.png";
import ClientDedicatedEnvironments from "../../assets/images/ClientDedicatedEnvironments.png";
import hero from "../../assets/images/hero.png";
import LandingFooter from "../../components/layout/landingFooter";
import cloudLeft from "../../assets/vector/Vector-8.png";
import cloudTop from "../../assets/vector/Vector-7.png";
import cloudFloat from "../../assets/vector/Vector-4.svg";
import cloudRight9 from "../../assets/vector/Vector-9.png";
import cloudRight5 from "../../assets/vector/Vector-5.png";

const ArchitecturePage = () => {
  return (
    <>
      <LandingHeader />
      <section className=" hero-tech hero-ryse-title arch-section">
        <div className="arch-bg">
          <img
            src={cloudRight5}
            alt=""
            className="arch-cloud arch-cloud--right"
          />
          <img src={cloudTop} alt="" className="arch-cloud arch-cloud--top" />
        </div>

        <div className="hero-tech">
          <div className="hero-ryse__content mw-900">
            <h1 className="hero-ryse__headline w-none">
              The Ryse Multi-Asset Analytics Platform — Architecture Overview
            </h1>
            <h2 className="hero-ryse__headline_sub">
              Advanced Mathematics · Cloud Computing · AI-Enabled Insights
            </h2>
          </div>
          <div/>  
        </div>
      </section>
      <section
        className="secure-arch arch-section vp-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img src={cloudLeft} alt="" className="arch-cloud arch-cloud--left" />
        </div>
        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">Introduction </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="content__title">
                A Modern Architecture Built for Institutional Analytics
              </h2>

              <p className="content__body">
                Ryse is engineered as a multi-layer analytical platform that
                unifies quantitative finance, cloud computing, and AI-driven
                intelligence. Each layer plays a distinct role — from data
                acquisition to mathematical computation to AI interpretation and
                intuitive user experiences.
              </p>
              <br />
              <p className="content__body">
                This interactive walkthrough reveals how the system transforms
                raw data into institutional-grade insights, all within a secure
                and scalable environment.
              </p>
            </div>
            <div className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={hero}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img
            src={cloudRight9}
            alt=""
            className="arch-cloud arch-cloud--right"
          />
        </div>
        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 1: Data & Integration Layer{" "}
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="content__title">Data & Integration Layer</h2>

              <p className="content__body">
                Where information enters, and accuracy begins.
              </p>
              <br />
              <p className="content__body">
                The foundation of the platform is a unified data framework that
                consolidates all asset classes into a clean, consistent
                structure.
              </p>
            </div>
            <div className="img-left">
              <div className="secure-arch__image-wrapper img-left">
                <img
                  src={integrationlayer}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="product-card bg-dark">
          <h3 className="text-square b">Includes:</h3>
          <ul>
            <li className="text-square">
              Market data (equities, fixed income, FX, commodities)
            </li>
            <li className="text-square">
              Alternative asset data (real estate, private partnerships, private
              equity)
            </li>
            <li className="text-square">Manager and custodian feeds </li>
            <li className="text-square">
              Pricing normalization and data cleansing
            </li>
            <li className="text-square">
              Cloud-based Data Lake/Warehouse for scalable storage
            </li>
          </ul>
          <b className="text-square b">Why it matters:</b>
          <p className="text-square">
            Accurate analytics require clean data. This layer ensures all inputs
            are reliable, synchronized, and ready for rigorous mathematical
            processing.
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20 p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img src={cloudLeft} alt="" className="arch-cloud arch-cloud--left" />
        </div>

        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 2: Financial & Mathematical Engine
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="rigth-img">
              <div className="secure-arch__image-wrapper ">
                <img
                  src={FinancialMathematicsEngine}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>

            <div className="secure-arch__content">
              <h2 className="content__title">Financial Mathematics Engine</h2>

              <p className="content__body">
                The quantitative core of the platform.
              </p>
              <br />

              <p className="content__body">
                This layer performs all institutional-grade portfolio
                calculations using both linear and non-linear financial
                mathematics.
              </p>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Capabilities include:</h3>

          <ul>
            <li className="text-square">Performance & attribution analytics</li>
            <li className="text-square">
              Portfolio aggregation across all structures
            </li>
            <li className="text-square">Risk factor modeling </li>
            <li className="text-square">Copula-based dependency estimation</li>
            <li className="text-square">Illiquid asset risk estimation</li>
            <li className="text-square">Stress tests & scenario simulation</li>
            <li className="text-square">Monte Carlo engines</li>
            <li className="text-square">Optimization and allocation</li>
          </ul>

          <b className="text-square b">Why it matters:</b>

          <p className="text-square">
            Ryse does not assume Gaussian behavior across assets. Instead, it
            models real-world distributions and dependencies — essential for
            portfolios containing private equity, real estate, hedge funds, or
            other alternatives.
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img
            src={cloudRight9}
            alt=""
            className="arch-cloud arch-cloud--right"
          />
        </div>

        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 3: AI & Intelligence Layer
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="content__title">AI Intelligence Layer</h2>

              <p className="content__body">
                Where complex analytics become intuitive.
              </p>
              <br />

              <p className="content__body">
                Generative AI serves as the communication layer, converting user
                questions into precise computational instructions executed by
                specialized Agents.
              </p>
            </div>

            <div className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={AIIntelligenceLayer}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Capabilities include:</h3>

          <ul>
            <li className="text-square">
              Natural-language understanding (“Explain my portfolio risk.”)
            </li>
            <li className="text-square">
              AI-driven diagnostics and portfolio explanations
            </li>
            <li className="text-square">
              Automated pattern recognition (drawdowns, exposures, liquidity)
            </li>
            <li className="text-square">
              Predictive modeling and scenario insights
            </li>
            <li className="text-square">AI audit trails and explainability</li>
          </ul>

          <b className="text-square b">Why it matters:</b>

          <p className="text-square">
            Users interact as if speaking to a team of experts — while every
            output is grounded in deterministic mathematics and verifiable
            computations.
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 4: Application & Visualization Layer
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
  <div className="rigth-img">
              <div className="secure-arch__image-wrapper">
                <img
                  src={chard}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>

            <div className="secure-arch__content">
              <h2 className="content__title">Applications & Visualization</h2>

              <p className="content__body">
                Analytics made clear and actionable.
              </p>
              <br />

              <p className="content__body">
                This layer transforms complex results into intuitive dashboards,
                reports, and real-time analytics.
              </p>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Capabilities include:</h3>

          <ul>
            <li className="text-square">Portfolio 360° Dashboard</li>
            <li className="text-square">Risk Explorer & Decomposition</li>
            <li className="text-square">Liquidity & Drawdown Analytics</li>
            <li className="text-square">What-If Scenario Simulator</li>
            <li className="text-square">
              Custom benchmarking & manager evaluation
            </li>
            <li className="text-square">
              Automatic reporting and PDF generation
            </li>
            <li className="text-square">Mobile-ready responsive UI</li>
          </ul>

          <b className="text-square b">Why it matters:</b>

          <p className="text-square">
            Institutional-level analytics become accessible to CIOs, analysts,
            and family office members with clear, interactive visuals.
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img
            src={cloudFloat}
            alt=""
            className="arch-cloud arch-cloud--left"
          />
        </div>

        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 5: Cloud Infrastructure & Security
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="content__title">Cloud Compute & Security Layer</h2>

              <p className="content__body">
                Performance, reliability, and trust.
              </p>
              <br />

              <p className="content__body">
                Ryse is deployed using modern cloud-native infrastructure,
                ensuring high performance and secure operations.
              </p>
            </div>

         <div  className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={cloud}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Components include:</h3>

          <ul>
            <li className="text-square">Distributed cloud compute cluster</li>
            <li className="text-square">Dockerized analytic engines</li>
            <li className="text-square">
              Auto-scaling of mathematical workloads
            </li>
            <li className="text-square">
              API layer for applications and agents
            </li>
            <li className="text-square">
              Full security stack (IAM, audit logs, encryption)
            </li>
            <li className="text-square">
              Global monitoring and uptime control
            </li>
          </ul>

          <b className="text-square b">Why it matters:</b>

          <p className="text-square">
            Even complex non-linear analytics run instantly, with
            enterprise-grade protection around all data and computations.
          </p>
        </div>
      </section>

      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="arch-bg">
          <img
            src={cloudFloat}
            alt=""
            className="arch-cloud arch-cloud--right"
          />
        </div>

        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">
            Layer 6: Client Private Environments
          </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
       <div className="rigth-img">
              <div className="secure-arch__image-wrapper">
                <img
                  src={ClientDedicatedEnvironments}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>

            <div className="secure-arch__content">
              <h2 className="content__title">Client-Dedicated Environments</h2>

              <p className="content__body">
                Privacy and customization for every client.
              </p>
              <br />

              <p className="content__body">
                Each organization receives a fully isolated environment tailored
                to its operational, regulatory, and analytical needs.
              </p>
            </div>
          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Capabilities include:</h3>

          <ul>
            <li className="text-square">Private tenant workspace</li>
            <li className="text-square">Data isolation and encryption</li>
            <li className="text-square">Dedicated compute resources</li>
            <li className="text-square">
              Optional on-premise inference appliance
            </li>
            <li className="text-square">
              Customizable models and risk frameworks
            </li>
            <li className="text-square">Bring-your-own-data support</li>
          </ul>

          <b className="text-square b">Why it matters:</b>

          <p className="text-square">
            Clients retain full control of their data while accessing
            cloud-level performance — or running completely on-prem for maximum
            confidentiality.
          </p>
        </div>
      </section>

      {/* FOLDOUt */}
      <section
        className="secure-arch arch-section vp-20  p-40-20"
        style={{ flexDirection: "column" }}
      >
        <div className="content-arch">
          <h1 className="hero-ryse__headline w-none">Complete Foldout </h1>
        </div>
        <div className="tech-arch__frame">
          <div className="secure-arch__inner">
            <div className="secure-arch__content">
              <h2 className="content__title">Full Architecture Blueprint</h2>

              <p className="content__body">
                A complete high-level diagram summarizing all layers: Data →
                Mathematics → AI → Applications → Cloud → Client Deployments.
              </p>
              <br />

              <p className="content__body">
                Ryse provides a unified, secure, and deeply mathematical
                foundation for modern multi-asset portfolio analytics — enhanced
                by AI, powered by cloud computing, and designed for
                institutional rigor.
              </p>
            </div>

         <div  className="img-left">
              <div className="secure-arch__image-wrapper">
                <img
                  src={arquImg}
                  alt="Secure architecture"
                  className="secure-arch__image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <LandingFooter />
    </>
  );
};

export default ArchitecturePage;
